export default __webpack_public_path__ + "static/media/branch_icon.002b8577.svg";